import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

// creates svg hourglass that creates divider between bar and actual progress
const createGapSvg = (color: string) => {
  const svg = `
    <svg xmlns='http://www.w3.org/2000/svg' width='10' height='8' viewBox='0.5 0.5 9 7'>
      <path d='M 0 0 L 10 0 L 10 8 L 0 8 Z M -4 4 A 4 4 0 0 0 4 4 A 4 4 0 0 0 -4 4 Z M 14 4 A 4 4 0 0 0 6 4 A 4 4 0 0 0 14 4 Z' fill='${color}'/>
    </svg>
  `
    .replace(/\s+/g, ' ')
    .trim();

  return `url("data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}")`;
};

export const flowLinearProgress: Components<Theme>['MuiLinearProgress'] = {
  defaultProps: {
    color: 'primary',
    size: 'medium',
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      height: '8px',
      borderRadius: '1000px',
      ...(ownerState.size === 'small' && {
        height: '2px',
      }),
      backgroundColor: theme.palette.mode === 'dark' ? theme.palette.onSurface.os700 : theme.palette.onSurface.os100,
      overflow: 'hidden',
      flexGrow: '1',
      position: 'relative',
      // dot at the end of progress
      '&::after': {
        content: '""',
        position: 'absolute',
        right: '0',
        top: '0',
        height: '100%',
        aspectRatio: '1 / 1',
        borderRadius: '1000px',
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.brand.secondary : theme.palette.brand.primary,
        zIndex: '20',
      },
    }),
    bar: ({ theme, ownerState }) => ({
      borderRadius: 'inherit',
      backgroundColor: theme.palette.mode === 'dark' ? theme.palette.brand.secondary : theme.palette.brand.primary,
      zIndex: '10',
      // right hourglass divider
      '&::before': {
        content: '""',
        position: 'absolute',
        top: '0',
        right: '0',
        transform: 'translateX(50%)',
        height: '100%',
        aspectRatio: '5 / 4',
        backgroundImage: createGapSvg(theme.palette.background.primary),
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      },
      ...(ownerState.variant === 'indeterminate' && {
        animation: '2s cubic-bezier(0.4, 0, 0.2, 1) infinite loader-indeterminate',
        '@keyframes loader-indeterminate': {
          '0%': {
            left: '-60%',
            right: '101%',
          },
          '100%': {
            left: '101%',
            right: '-60%',
          },
        },
        // left hourglass divider
        '&::after': {
          content: '""',
          position: 'absolute',
          top: '0',
          left: '0',
          transform: 'translateX(-50%)',
          height: '100%',
          aspectRatio: '5 / 4',
          backgroundImage: createGapSvg(theme.palette.background.primary),
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        },
      }),
    }),
    bar2: {
      display: 'none',
    },
  },
};
